export default __webpack_public_path__ + "static/media/Double-edged Rencounter.33276eab.png";